import {connect} from 'react-redux';
import Constants, {ModalStates, AnnotationModes} from '../../globals/Constants';
import RouterWithSplash, {RouterWithSplashProps} from './RouterWithSplash';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import Action from '../../redux/Actions';

const mapStateToProps = (state: ReduxState): Partial<RouterWithSplashProps> => {
   return {
      themeName: state.themeName || Constants.themeName.default,
      authorization: state.authorization,
      showPageLoadingSpinner: state.pageIsLoading,
      annotationMode: state.annotationMode
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<RouterWithSplashProps> => {
   return {
      setAnnotationMode: (annotationMode: AnnotationModes) => {
         dispatch(Action.setAnnotationMode(annotationMode));
      },
      setModalState: (modalState: ModalStates) => {
         dispatch(Action.setModalState({modalState: modalState}));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterWithSplash);
